import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import PageContainer from "shared/components/pagecontainer/PageContainer";
import styles from "./TodasCategorias.module.scss";
import { ICategoria } from "shared/interfaces/ICategoria";
import { buscarCategorias } from "shared/services/api/categoria.api";
import { LayoutGrid } from "lucide-react";

const categoriasVisuais: Record<string, { imagem: string }> = {
  "calcados-roupas-e-bolsas": { imagem: "/imagens/categorias/roupas.png" },
  "tv-video-e-eletronicos": {imagem: "/imagens/categorias/eletronicos.png", },
  eletrodomesticos: { imagem: "/imagens/categorias/eletrodomesticos.png" },
  construcao: { imagem: "/imagens/categorias/construcao.png" },
  casa: {imagem:"/imagens/categorias/decoracoes.png"},
  "brinquedos-e-hobbies": { imagem: "/imagens/categorias/brinquedos.png" },
  farmacia: { imagem: "/imagens/categorias/farmacia.png" },
  games: { imagem: "/imagens/categorias/games.png" },
  "agropecuarias-e-pet": { imagem: "/imagens/categorias/agro.png" },
  "beleza-e-cuidado-pessoal": {imagem: "/imagens/categorias/cuidados.png",},
  "antiguidades-e-colecoes": { imagem: "/imagens/categorias/antiguidades.png" },
  "joias-e-acessorios": { imagem: "/imagens/categorias/joias.png" },
  "moda-infantil": { imagem: "/imagens/categorias/moda infantil.png" },
  "cameras-e-acessorios": { imagem: "/imagens/categorias/cameras.png" },
  "celulares-e-acessorios": { imagem: "/imagens/categorias/celulares.png" },
  "arte-papelaria-e-armarinho": {imagem: "/imagens/categorias/papelaria.png",},
  "artigos-religiosos": {imagem: "/imagens/categorias/artigosreligiosos.png",},
  veiculos: {imagem: "/imagens/categorias/veiculos.png", },
  saude: {imagem: "/imagens/categorias/saude.png", },
  "esportes-e-fitness": { imagem: "/imagens/categorias/fitness.png" },
  outros: { imagem: "/imagens/categorias/outros.png" },
};

export const TodasCategorias: React.FC = () => {
  const navigate = useNavigate();
  const [categorias, setCategorias] = useState<ICategoria[]>([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    carregarCategorias();
  }, []);

  async function carregarCategorias() {
    try {
      setLoading(true);
      const lista = await buscarCategorias();
      setCategorias(lista);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  }

  return (
    <PageContainer title="Categorias" icon={<LayoutGrid size={18} />} contentClassName={styles.whiteContent}>
      <div className={styles.page}>
        {loading ? (
          <p>Carregando categorias...</p>
        ) : categorias.length === 0 ? (
          <p>Nenhuma categoria encontrada.</p>
        ) : (
          <div className={styles.grid}>
            {categorias.map((categoria) => {
              const visual = categoriasVisuais[categoria.slug] ?? {
                imagem: "/imagens/categorias/default.png",
              };

              return (
                <div
                  key={categoria.id}
                  className={styles.item}
                  onClick={() => navigate(`/listarprodutos?categoria=${categoria.slug}&categoriaId=${categoria.id}`,)}
                  style={{ cursor: "pointer" }}
                >
                  <div className={styles.circle}>
                    <img
                      src={visual.imagem}
                      alt={categoria.nome}
                      className={styles.imagemCategoria}
                    />
                  </div>
                  <p className={styles.label}>{categoria.nome}</p>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </PageContainer>
  );
};
